const baseUrl = "https://erp-elsalab.odoo.com";

// Check product stock availability
export async function checkProductStock(productId) {
  const url = `${baseUrl}/api/cs/product-stock?id=${productId}`;
  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "text/plain" },
    });

    if (!res.ok) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(
        message || `Failed to fetch stock data with status ${res.status}`
      );
    }

    const data = await res.json();

    if (data?.data && Array.isArray(data.data) && data.data.length > 0) {
      const stockData = data.data[0];

      // Debug: log all available fields in the stock data
      console.log("Available stock fields:", Object.keys(stockData));
      console.log("Stock data values:", stockData);

      // Try different possible field names for free quantity
      const freeQty =
        stockData.free_qty ||
        stockData.freeQty ||
        stockData.total_free ||
        stockData.available ||
        stockData.qty_available ||
        stockData.quantity ||
        0;

      console.log("Final freeQty value:", freeQty, typeof freeQty);
      return Number(freeQty);
    }

    throw new Error("No stock data available");
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while fetching stock"
      : e?.message || "Failed to fetch stock data";
    throw new Error(msg);
  }
}
